import { useState } from 'react'
import {
  Create,
  SimpleForm,
  required,
  TextInput,
  useDataProvider,
} from 'react-admin'
import {
  Dialog,
  DialogTitle,
  Button,
  Typography,
  Toolbar,
} from '@material-ui/core'
import CheckIcon from '@mui/icons-material/Check'
import FileWithContext from '../models/file_with_context'
import UpsertFileButton from '../components/file_upload'
import Relation from '../models/relation'
import BindFile from '../exceptions/file_with_context/bind_file'

export const AskAccountingQuestion = (props) => {
  const { refresh } = props
  const [files, setFiles] = useState([])
  const dataProvider = useDataProvider()

  //NOTE: we need ticket_fields info for dataprovider, so that it can convert image fields to base64
  const init_values = {
    ticket_fields: [],
    copro_id: props.copro_id,
    coproprietaire_id: props.coproprietaire_id,
    process_id: '20',
  }

  const onFailure = (error) => {
    alert(`${error.message}`)
  }
  const onSuccess = (dataSucces) => {
    const { id } = dataSucces
    const relation = new Relation({
      linkable_type: 'tickets',
      linkable_id: id,
      copro_id: props.copro_internal_id,
    })
    if (files && files.length > 0) {
      dataProvider
        .updateMany('ext_file_with_context', {
          ids: files.map((f) => f.id),
          data: relation.toJSON(),
        })
        .then(() => {
          alert(
            `Merci ! Votre demande a été enregistrée sous le numéro : ${dataSucces.id}. Elle va être confirmée par notre équipe Support (c'est important, notamment pour ne pas lancer plusieurs interventions pour un même incident).`
          )
          refresh()
          props.setShow(false)
        })
        .catch((e) => {
          throw new BindFile('tickets', id, files.map((f) => f.id).join(', '))
        })
    } else {
      alert(
        `Merci ! Votre demande a été enregistrée sous le numéro : ${dataSucces.id}. Elle va être confirmée par notre équipe Support (c'est important, notamment pour ne pas lancer plusieurs interventions pour un même incident).`
      )
      props.setShow(false)
      refresh()
    }
  }

  return (
    <Dialog
      open={props.show}
      onClose={() => {
        props.setShow(false)
      }}
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle>Poser une question comptable</DialogTitle>
      <Create
        {...props}
        onFailure={onFailure}
        mutationOptions={{ onSuccess }}
        resource="ext_accounting_tickets"
        basePath="/"
      >
        <SimpleForm
          variant="standard"
          defaultValues={init_values}
          toolbar={<FormToolbar />}
        >
          <Typography variant="subtitle1" fullWidth gutterBottom>
            Vous avez la possibilité de poser une question comptable ! Pour cela
            il vous suffit de remplir le formulaire ci-dessous. 🚀
          </Typography>
          <TextInput
            fullWidth
            source="libelle"
            label="Titre (en quelques mots)"
            validate={[required()]}
          />
          <TextInput
            multiline={true}
            fullWidth
            source="description"
            label="Description"
            validate={[required()]}
          />
          <Typography
            variant="subtitle1"
            fullWidth
            gutterBottom
            style={{ color: '#143A5F' }}
          >
            Documents divers
          </Typography>
          <UpsertFileButton
            // enable_external={true}
            expectProvider={false}
            fromPath="ext_coproprietaires"
            basePath="/"
            resource="ext_file_with_context"
            documentType={FileWithContext.DOCUMENT_TYPE.INTERVENTION}
            issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
            linkable_type="tickets"
            copro_id={props.copro_internal_id}
            linkable_id={null}
            upload_by={props?.coproprietaire.id}
            upload_by_type={null}
            validCategories={[FileWithContext.CATEGORY.ACCOUNTING]}
            saveResult={(result) => {
              if (result.accepted_files && result.accepted_files.length > 0) {
                setFiles(result.accepted_files)
              }
            }}
          />
        </SimpleForm>
      </Create>
    </Dialog>
  )
}

const FormToolbar = (props) => {
  return (
    <Toolbar>
      <Button
        color="primary"
        variant="contained"
        disableElevation
        startIcon={<CheckIcon />}
        type="submit"
      >
        Enregistrer
      </Button>
    </Toolbar>
  )
}
